import { defineStore } from 'pinia';
import { getComputeLabStorageInitStateApi, exrcComputeLabStorageInitApi } from '@/api/storage';
interface ComputeLabState {
    InitStoraged: boolean;
    loading: boolean;
}
export const useComputeLabStore = defineStore({
    id: 'ModelBooster',
    state: (): ComputeLabState => ({
        InitStoraged: false,
        loading: false,
    }),
    actions: {
        async getStorageStatus() {
            try {
                const status = await getComputeLabStorageInitStateApi();
                this.InitStoraged = status;
                // await new Promise((resolve) => {
                //     setTimeout(() => {
                //         this.InitStoraged = false;
                //         resolve(1);
                //     }, 10000);
                // });
            } catch (e) {
                console.error(e);
            }
        },
        async execInitStorage() {
            try {
                this.loading = true;
                // TODO: API
                await exrcComputeLabStorageInitApi();
                this.InitStoraged = true;
                // await new Promise((resolve) => {
                //     setTimeout(() => {
                //         // 初始化成功
                //         this.InitStoraged = true;
                //         resolve(1);
                //     }, 6000);
                // });
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
            }
        },
    },
});
